import(/* webpackMode: "eager" */ "/app/app/(public)/spaces-api/page.tsx");
